import { WriteoffApprovalView } from '../../../../../../services/WriteoffService/types/writeoffTypes';

/**
 * Determines if a user can act on a specific approval level.
 * Previous levels must all be approved before acting on current level.
 */
export const canActOnApprovalLevel = (
  approval: WriteoffApprovalView,
  approvals: WriteoffApprovalView[]
): boolean => {
  // Already acted on - can view/change
  if (approval.isApproved || approval.isRejected) return true;
  
  // Check all previous levels are approved
  const previousLevels = approvals.filter(a => a.level < approval.level);
  return previousLevels.every(a => a.isApproved);
};

/**
 * Determines if the current user can approve a specific approval.
 */
export const canUserApprove = (
  approval: WriteoffApprovalView,
  userDisplayName: string,
  approvals: WriteoffApprovalView[]
): boolean => {
  const canActOnLevel = canActOnApprovalLevel(approval, approvals);
  const isApprover = userDisplayName === approval.requiredApprover || 
                     userDisplayName === approval.backupApprover;
  
  return isApprover && userDisplayName.length > 0 && canActOnLevel;
};
